import React from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';
import { ListItem, ListItemText, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
	linkText: {
		marginLeft: theme.spacing(0.5)
	}
}));

export const ListItemLink = (props: ListItemLinkProps): JSX.Element => {
	const { icon, label, to, testid } = props;
	const classes = useStyles();
	return (
		<ListItem
			button
			component={React.forwardRef((props: RouterLinkProps, ref: React.Ref<HTMLAnchorElement>) => (
				<RouterLink {...props} innerRef={ref} data-testid={testid} />
			))}
			to={to}
			key={label}>
			{' '}
			{icon && icon}
			<ListItemText primary={label} className={classes.linkText} />
		</ListItem>
	);
};

export const ListItemATagLink = (props: ListItemATagLinkProps): JSX.Element => {
	const { icon, label, href, target } = props;
	const classes = useStyles();

	return (
		<a href={href} target={target} className='MuiButtonBase-root MuiListItem-root MuiListItem-gutters MuiListItem-button'>
			{icon && icon}
			<ListItemText primary={label} className={classes.linkText} />
		</a>
	);
};

type ListItemLinkProps = {
	icon?: JSX.Element;
	label: string;
	to: string;
	testid?: string;
};

type ListItemATagLinkProps = {
	icon?: JSX.Element;
	label: string;
	href: string;
	target?: string;
};
